import { render, staticRenderFns } from "./DokuRohstoffe.vue?vue&type=template&id=f14c5caa&scoped=true"
import script from "./DokuRohstoffe.vue?vue&type=script&lang=js"
export * from "./DokuRohstoffe.vue?vue&type=script&lang=js"
import style0 from "./DokuRohstoffe.vue?vue&type=style&index=0&id=f14c5caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14c5caa",
  null
  
)

export default component.exports